export const DIGITAL_DELIVERY = 'Digital delivery';
